import { buildUrl } from "@payping/utilities-shared/url";
import { useAsync } from "react-use";
import { Flex, Image, Skeleton, Typography } from "@payping/web-components";
import { useAppTranslation } from "@/utils";
import { blogCardId } from "@/assets/googleTrackIds";
import type { BlogPostFormStorage } from "./types";
import { URLS } from "@payping/utilities-shared/consts";

const Post = ({ post }: { post: BlogPostFormStorage }) => (
  <Typography.Link target="_blank" href={post.permalink} data-google-track={blogCardId}>
    <Flex className={"w-100"} style={{ border: "1px solid #f0f0f0", borderRadius: "2px" }}>
      <Flex>
        <Image
          style={{ borderRadius: "0 2px 2px 0" }}
          width={"100px"}
          height={"100px"}
          alt={post.title}
          preview={false}
          src={post.thumbnail}
        />
      </Flex>
      <Flex className={"w-100"} align={"center"}>
        <Typography.Text type={"secondary"} className={"tw:px-4! tw:text-center"}>
          {post.title}
        </Typography.Text>
      </Flex>
    </Flex>
  </Typography.Link>
);

const BlogPosts = () => {
  const { t } = useAppTranslation();
  const { loading, value } = useAsync(async () => {
    const response = await fetch(buildUrl(URLS.STORAGE_URL, "documents/feed.json").toString());
    const latestPost: BlogPostFormStorage = await response.json();
    return latestPost;
  }, []);

  if (loading) {
    return <Skeleton active paragraph />;
  }
  if (!value) return null;

  return (
    <Flex vertical className="tw:w-full">
      <Flex className="tw:my-4!">
        <Typography.Title level={5}>{t("overview.blogPosts.title")}</Typography.Title>
        <Typography.Link href={URLS.BLOG_URL} target="_blank" className="tw:mr-auto">
          {t("overview.blogPosts.showAll")}
        </Typography.Link>
      </Flex>
      <Post post={value} />
    </Flex>
  );
};

export default BlogPosts;
